import PaidIcon from '@mui/icons-material/Paid';
import { useTranslation } from 'react-i18next';
import { formatNumberWithCommas } from '@/utils/helpers';
import StatWidgetBox from './StatWidgetBox';
import { useGetBannersQuery } from '@/api/banners';
import { useSelector } from 'react-redux';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';
import TooltipStack from './partials/TooltipStack';
import TooltipContentContainer from './partials/TooltipContentContainer';

const PaidChip = ({onClick, open}) => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner, isLoading } = useGetBannersQuery(activeBuildingId);
  const daySum = banner?.pay_sum?.day_sum;
  
  return (
    <StatWidgetBox
      icon={<PaidIcon sx={{ fontSize: 16 }} />}
      value={`${formatNumberWithCommas(daySum) || '0'}₸`}
      loading={isLoading}
      skeletonWidth={36}
      onClick={onClick}
      tooltipContent={open && <TooltipContent />}
    />
  );
};

const TooltipContent = () => {
  const { t } = useTranslation();
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner } = useGetBannersQuery(activeBuildingId);

  return (
    <TooltipContentContainer
      backgroundColor={'rgb(53, 177, 142)'}
      backgroundGradient="linear-gradient(140.9deg, rgb(144, 202, 249) -14.02%, rgba(144, 202, 249, 0) 77.58%)"
      icon={<PaidIcon sx={{ fontSize: 14, color: 'white' }} />}
      iconBackground={'rgb(14, 148, 110)'}
      title={t('paid')}
    >
      <TooltipStack 
        items={[
          { label: t('month'), value: banner?.pay_sum?.month_sum },
          { label: t('week'), value: banner?.pay_sum?.week_sum },
          { label: t('day'), value: banner?.pay_sum?.day_sum }
        ]}
        colorTheme="light"
        backgroundColor="rgb(255, 255, 255)"
        valueTransformFn={value => `${formatNumberWithCommas(value) || '0'}₸`}
      />
    </TooltipContentContainer>
  )
}

export default PaidChip;
